import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from "@angular/router";
import {AuthGuardWithForcedLogin} from "src/app/core/auth-guard-with-forced-login.service";
import { PayerMappingComponent } from './payer-mapping.component';
import { PayerDetailsComponent } from './payer-details/payer-details.component';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EditDetailsComponent } from './edit-details/edit-details.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { DeleteMappingComponent } from './delete-mapping/delete-mapping.component';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@NgModule({
    declarations: [
        PayerDetailsComponent,
        PayerMappingComponent,
        EditDetailsComponent,
        DeleteMappingComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: 'payerMapping',
                component: PayerMappingComponent,
                canActivate: [AuthGuardWithForcedLogin]
            }
        ]),
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatSortModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatSidenavModule,
        MatListModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule
    ],
    providers: [
        {provide: MAT_DIALOG_DATA, useValue: {}},
    ],
})
export class PayerMappingModule {
}